import type { SearchContext } from '@shared/types/types';

/**
 *
 *
 */
const ASSORTMENTS_WITH_TOP_INFO = [
    'Haushaltsgeräte',
    'Unterhaltungselektronik',
    'Optik',
    'Kommunikation',
    'Reinigungsgeräte',
    'Klima',
    'Bürotechnik',
    'Fahrzeuge',
    'Gartengeräte',
    'Heizen',
    'Sportausrüstung',
    'Zahnpflege',
    'Elektroinstallation',
] as const;

const ASSORTMENTS_SET = new Set(ASSORTMENTS_WITH_TOP_INFO.map((item) => item.toLowerCase()));

function normalizeAssortment(searchContext: SearchContext | undefined): string | undefined {
    const assortment = searchContext?.assortment;
    return assortment ? assortment.toLowerCase() : undefined;
}

export function shouldShowTopInfos(searchContext: SearchContext | undefined): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    return ASSORTMENTS_SET.has(normalized);
}
